var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.728027,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9836 16.1058C15.5636 17.3138 16.3542 18.446 17.3555 19.4474C18.3568 20.4487 19.4891 21.2393 20.6971 21.8193C20.801 21.8692 20.8529 21.8942 20.9187 21.9133C21.1523 21.9814 21.4392 21.9325 21.637 21.7908C21.6927 21.751 21.7403 21.7033 21.8356 21.6081C22.1269 21.3167 22.2726 21.1711 22.4191 21.0758C22.9715 20.7167 23.6837 20.7167 24.2361 21.0758C24.3825 21.1711 24.5282 21.3167 24.8196 21.6081L24.9819 21.7705C25.4248 22.2133 25.6462 22.4348 25.7665 22.6726C26.0058 23.1456 26.0058 23.7041 25.7665 24.1771C25.6462 24.4149 25.4248 24.6363 24.9819 25.0792L24.8506 25.2106C24.4092 25.6519 24.1886 25.8726 23.8885 26.0411C23.5556 26.2281 23.0385 26.3626 22.6567 26.3615C22.3126 26.3605 22.0774 26.2937 21.607 26.1602C19.0792 25.4427 16.6939 24.089 14.7039 22.099C12.7139 20.109 11.3602 17.7237 10.6427 15.1959C10.5092 14.7255 10.4424 14.4903 10.4414 14.1462C10.4403 13.7644 10.5747 13.2473 10.7618 12.9144C10.9303 12.6143 11.151 12.3937 11.5923 11.9523L11.7237 11.8209C12.1666 11.3781 12.388 11.1566 12.6258 11.0364C13.0988 10.7971 13.6573 10.7971 14.1303 11.0364C14.3681 11.1566 14.5896 11.3781 15.0324 11.8209L15.1948 11.9833C15.4862 12.2747 15.6318 12.4203 15.7271 12.5668C16.0862 13.1192 16.0862 13.8314 15.7271 14.3838C15.6318 14.5303 15.4862 14.6759 15.1948 14.9673C15.0996 15.0625 15.0519 15.1102 15.0121 15.1658C14.8704 15.3637 14.8215 15.6506 14.8896 15.8842C14.9087 15.95 14.9337 16.0019 14.9836 16.1058Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCircle);
export default __webpack_public_path__ + "static/media/phoneCircle.d36928cd399fbd0a17d87b1b88655c0f.svg";
export { ForwardRef as ReactComponent };